module.exports = __webpack_public_path__ + "static/todamateria-1e21bdfe6299de2aa67cfbce6f40b6a3.mp4";